import Button from '@/common/components/Button'
import { flattedRoutes } from '@/common/Layout/Sidebar/routes'
import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'

interface NotFoundErrorMessageProps {
  fallback?: string
  buttonText?: string
  className?: string
  hideButton?: boolean
}

export const NotFoundErrorMessage = ({ fallback, buttonText, className, hideButton }: NotFoundErrorMessageProps) => {
  const navigate = useNavigate();

  const location = useLocation()

  const route = useMemo(() => {
    const firstPath = location?.pathname?.split('/')?.[1] || ''

    if (firstPath)
      return flattedRoutes.find(({ path }) => path === `/${firstPath}`)

    return {
      path: '/company',
      label: 'Minha empresa',
    }
  }, [location?.pathname])

  return (
    <div className={twMerge('flex w-full flex-col items-center gap-3 h-screen overflow-auto', className)}>
      <div className="mt-auto">
        <img src="/cloud.gif" className="shrink-0 w-64 sm:w-[305px]" />
      </div>

      <div className="flex flex-col items-center -mt-16 mb-auto sm:p-8">
        <p className="text-sm font-bold">
          Ops! Não tem nada por aqui...
        </p>

        <p className="text-xs mt-2">
          O recurso que você está procurando não foi encontrado.
        </p>

        {!hideButton && (
          <Button onClick={() => navigate(fallback || route?.path as string || '/company')} className="mt-4">
            {buttonText || `Ir para ${route?.label || 'Minha empresa'}`}
          </Button>
        )}
      </div>
    </div>
  )
}

export const NotFoundPage = () => <NotFoundErrorMessage className='h-[calc(100vh-64px)]' />;

export const NotFoundMobileScreen = () => (
  <NotFoundErrorMessage
    className='w-screen h-dvh'
    fallback='/home'
    buttonText='Ir para tela inicial'
  />
);
